import {
  IconButton as IconButtonMui,
  IconButtonProps as IconButtonPropsMui,
} from '@mui/material';
import { forwardRef } from 'react';

export type IconButtonProps = Pick<
  IconButtonPropsMui,
  'children' | 'onClick' | 'edge' | 'color' | 'size' | 'aria-labelledby'
>;

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ ...rest }, ref) => {
    return <IconButtonMui ref={ref} {...rest} />;
  },
);
